import React from 'react';
import styles from './Skeleton.module.css';

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  circle?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

/** Bloque de carga con efecto shimmer. */
const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height = 14,
  radius,
  circle,
  className,
  style,
}) => (
  <span
    className={[styles.skeleton, circle ? styles.circle : '', className || '']
      .filter(Boolean)
      .join(' ')}
    style={{
      width: width ?? '100%',
      height,
      borderRadius: circle ? '50%' : radius,
      ...style,
    }}
  />
);

/** Varias líneas de texto skeleton. */
export const SkeletonText: React.FC<{ lines?: number; lastWidth?: string }> = ({
  lines = 3,
  lastWidth = '60%',
}) => (
  <span className={styles.text}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton key={i} height={12} width={i === lines - 1 ? lastWidth : '100%'} />
    ))}
  </span>
);

export default Skeleton;
